<template>
    <div class="v-main grey lighten-4 m-0 pa-3 pt-10">
      <div class="v-main__wrap">
        <div class="container container--fluid">
          <div class="v-card--material pa-3  v-card v-sheet theme--light elevation-2">
            <span class="subtitle-2">Create / View Schedule</span>
            <v-row>
            <v-col cols="12" md="4" lg="4" sm="4" xs="12">
              <v-autocomplete
                name="round"
                v-model="selectedRound"
                :items="formattedPeriods"
                required
                item-value="id"
                item-text="period"
              >
                <template v-slot:label>
                  Round Duration <span class="error--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" sm="3" xs="12">
              <v-autocomplete
                v-model="selectedStatus"
                :items="schedulingStatus"
                item-text="status"
                item-value="id"
                key="id"
                required
              >
                <template v-slot:label>
                  Status
                  <span class="error--text">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" lg="3" sm="3" xs="12">
              <div class="d-flex caption">
                <v-btn
                  small
                  id="apply"
                  color="success"
                  elevation="1"
                  type="submit"
                  class="ml-2 mt-5"
                  @click="filterTable()"
                >
                  <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                  Filter
                </v-btn>
                <v-btn
                  small
                  elevation="1"
                  type="reset"
                  @click="resetAll()"
                  class="ml-2 mt-5"
                >
                  <v-icon left size="18"> mdi-restart</v-icon> Clear
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <template>
                  <v-data-table
                    :headers="headers"
                    :items="filteredData"
                    item-key="id"
                    disable-pagination
                    :hide-default-footer="true">

                    <template v-slot:[`item.status`]="{ item }">
                      <div @click="openPopup(item)">
                        {{item.status }}
                      </div>
                    </template>

                    <template v-slot:[`item.schedule`]="{ item }">
                      <v-btn @click="handleScheduleClick(item)">
                        {{ getScheduleLabel(item.status) }}
                      </v-btn>
                    </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
          </div>
          </div>
        </div>

        <v-dialog v-model="statusDialog" max-width="900px">
          <div class="d-flex justify-content-center pa-3 v-card--material v-card v-sheet theme--light">
            <span class="subtitle-2">View Details</span>
          </div>
            <div class="pa-3 bg-white">
              <v-data-table
              :headers="detailsPopUpHeader"
              :items="popUpDetail"
              item-key="id"
              disable-pagination
              :hide-default-footer="true"
              ></v-data-table>
            </div>
      </v-dialog>
      </div>

</template>

<script>
import stores from '../../stores'
import constants from '../../utils/constants'
export default {
  name: 'testing',
  data () {
    return {
      headers: [
        { text: 'Round', value: 'round', sortable: true, align: 'center' },
        { text: 'Start Date-End Date', value: 'formattedDate', sortable: true, align: 'center' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' },
        { text: 'Schedule', value: 'schedule', align: 'center' }
      ],
      detailsPopUpHeader: [
        { text: 'Date', value: 'date', sortable: true, align: 'center' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' },
        { text: 'Reason', value: 'reason', sortable: true, align: 'center' }
      ],
      schedulingStatus: [
        'Not Created Yet',
        'Pending For Approval',
        'Rejected',
        'Approved'
      ],
      amsUserID: stores.user.me.id,
      selectedStatus: '',
      selectedRound: '',
      scheduleData: [],
      filteredData: [],
      statusDialog: false,
      popUpDetail: []
    }
  },
  created () {
    this.getRoundData()
  },
  computed: {
    formattedPeriods () {
      return this.scheduleData.map(period => ({
        period: `${this.formatDate(period.startDate)} - ${this.formatDate(period.endDate)}`,
        ...period
      }))
    }
  },
  mounted () {
    this.filteredData = this.scheduleData
  },
  methods: {
    getScheduleLabel (status) {
      switch (status) {
        case 'Not Created Yet':
          return 'Create'
        case 'Pending for Approval':
          return 'View'
        case 'Rejected':
          return 'Edit'
        case 'Approved':
          return 'View'
        default:
          return ''
      }
    },
    handleScheduleClick (item) {
      // Handle the button click based on the item's status or other properties
      console.log(`${this.getScheduleLabel(item.status)} button clicked for round ${item.round}`)
    },
    getRoundData: async function () {
      try {
        let payload = {
          'amUserId': this.amsUserID,
          // "zmUserId":"48765263-a6d3-4d4b-b430-2e7edcdc2af2",
          // "roundId":"",

          'status': ''
        }
        const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getRondList`, payload)
        data.sort((a, b) => a.round - b.round)
        // Create the formattedDate key
        this.scheduleData = data.map(item => {
          return {
            ...item,
            formattedDate: `${this.formatDate(item.startDate)} - ${this.formatDate(item.endDate)}`
          }
        })
        this.filteredData = this.scheduleData
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    formatDate (dateStr) {
      const date = new Date(dateStr)
      const options = { day: 'numeric', month: 'long', year: 'numeric' }
      return date.toLocaleDateString('en-GB', options)
    },
    filterTable () {
      try {
        this.filteredData = this.scheduleData.filter(item => {
          const matchesRound = this.selectedRound ? item.formattedDate === this.selectedRound : true
          const matchesStatus = this.selectedStatus ? item.status === this.selectedStatus : true
          return matchesRound && matchesStatus
        })
      } catch (error) {
        console.log('error ====>', error)
      }
    },
    resetAll () {
      this.selectedRound = ''
      this.selectedStatus = ''
      this.filteredData = this.scheduleData
    },
    openPopup: async function (item) {
      console.log('item ===>', item)
      let payload = {
        roundId: item.roundId
      }
      const { data } = await http.post(`${constants.API_URL}/api/amsScheduling/createSchedule/getRoundStatusLog`, payload)
      console.log('data ########', data)
      this.popUpDetail = data
      this.statusDialog = true
    },
    errMsg (msg) {
      console.log('errMsg msg ====>', msg)
      // return this.$dialog.error({
      //   text: msg,
      //   title: 'Error'
      // })
    }
  }
}
</script>
<style>
.bg-white{
  background-color: #FFFFFF;
}
</style>
